import flatpickr from 'flatpickr';
import German from 'flatpickr/dist/l10n/de.js';

function initFlatPickr() {
    const arrivalInput = document.querySelector('#inquiryFormHotel-arrivalDate');
    const departureInput = document.querySelector('#inquiryFormHotel-departureDate');

    if (!arrivalInput || !departureInput) {
        return;
    }

    let minDepartureDate = arrivalInput.value ? new Date(arrivalInput.value) : null;

    const commonOptions = {
        // today + 1 day
        minDate: new Date().fp_incr(1),
        altFormat: 'd. m. Y',
        altInput: true,
        locale: document.documentElement.lang || 'en',
        // we need this for HTML 5 validation
        // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
        allowInput: true
    };

    const arrivalFlatPickr = flatpickr(arrivalInput, commonOptions);
    const departureFlatPickr = flatpickr(departureInput, commonOptions);

    if (minDepartureDate instanceof Date) {
        departureFlatPickr.config.minDate = minDepartureDate;
    }

    arrivalFlatPickr.config.onChange.push(selectedDates => {
        if (selectedDates.length > 0) {
            minDepartureDate = selectedDates[0];
        }

        if (minDepartureDate instanceof Date) {
            departureFlatPickr.config.minDate = minDepartureDate;
        }
    });

    // we need this for HTML 5 validation
    // see https://github.com/flatpickr/flatpickr/issues/892#issuecomment-477338832
    arrivalInput.nextElementSibling.onkeypress = () => false;
    departureInput.nextElementSibling.onkeypress = () => false;
}
initFlatPickr();

function showChildAgeFields() {
    const childAgeFields = document.querySelectorAll('.js-child-age');
    const childField = document.querySelector('.js-children');

    if (!childAgeFields || !childField) {
        return;
    }
    function removeFields() {
        const childFieldValue = parseInt(childField.value);

        [...childAgeFields].forEach((childAgeField, index) => {
            if (index > childFieldValue - 1 || !childFieldValue) {
                childAgeField.classList.add('input--hidden');
                childAgeField.querySelector('input').value = '';
            } else {
                childAgeField.classList.remove('input--hidden');
            }
        });
    }

    removeFields();

    childField.addEventListener('input', removeFields);
}

showChildAgeFields();
